module.exports = __webpack_public_path__ + "static/media/icon-www.1c429e80.svg";